import {parseDate} from 'shared/web';

import {
  GetServiceCaseIntegrationsClaraClaimApiResponse,
  GetServiceCaseIntegrationsClaraClaimDetailApiResponse,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
} from '../types';

export const evaClaimAdditionalInformationEmptyMockResponse: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse =
  {
    damageCode: null,
    isPartClaimDamage: false,
    partClaimData: null,
  };

export const evaClaimAdditionalInformationFilledMockResponse: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse =
  {
    damageCode: 'DMG1234',
    isPartClaimDamage: true,
    partClaimData: {
      installationDate: parseDate('2024-01-15'),
      installationMileage: 50000,
      replacedByDealer: 'Dealer123',
      replacedPartNumber: 'PART567',
    },
  };

export const evaClaimAdditionalInformationWithoutPartClaimMockResponse: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse =
  {
    damageCode: 'DMG7890',
    isPartClaimDamage: false,
    partClaimData: null,
  };

export const claraClaimVehicleMockResponse: GetServiceCaseIntegrationsClaraClaimApiResponse = {
  claimType: '0',
  repairStartDate: '2024-01-15',
  mileageStart: 50000,
  repairEndDate: '2024-01-20',
  mileageEnd: 50100,
  partPurchaseDate: null,
  mileagePartPurchase: null,
  partNumber: null,
  attachments: [],
};

export const claraClaimPartMockResponse: GetServiceCaseIntegrationsClaraClaimApiResponse = {
  claimType: '1',
  repairStartDate: '2024-02-01',
  mileageStart: 60000,
  repairEndDate: '2024-02-05',
  mileageEnd: 60200,
  partPurchaseDate: '2024-01-10',
  mileagePartPurchase: 55000,
  partNumber: 'PART-123',
  attachments: [
    {
      fileId: 'file-1',
      filename: 'invoice.pdf',
      contentType: 'application/pdf',
    },
    {
      fileId: 'file-2',
      filename: 'damage-photo.jpeg',
      contentType: 'image/jpeg',
    },
  ],
};

export const claraClaimEmptyMockResponse: GetServiceCaseIntegrationsClaraClaimApiResponse = {
  claimType: '',
  repairStartDate: '',
  mileageStart: null,
  repairEndDate: '',
  mileageEnd: null,
  partPurchaseDate: null,
  mileagePartPurchase: null,
  partNumber: null,
  attachments: [],
};

export const claraClaimWithAttachmentsMockResponse: GetServiceCaseIntegrationsClaraClaimApiResponse =
  {
    claimType: '0',
    repairStartDate: '2024-03-01',
    mileageStart: 70000,
    repairEndDate: '2024-03-05',
    mileageEnd: 70100,
    partPurchaseDate: null,
    mileagePartPurchase: null,
    partNumber: null,
    attachments: [
      {
        fileId: 'existing-file-1',
        filename: 'warranty-doc.pdf',
        contentType: 'application/pdf',
      },
      {
        fileId: 'existing-file-2',
        filename: 'part-photo.png',
        contentType: 'image/png',
      },
    ],
  };

export const claraClaimDetailMockResponse: GetServiceCaseIntegrationsClaraClaimDetailApiResponse = {
  claimNumber: 'CLR-2024-001',
  claimType: '0',
  status: 'APPROVED',
  statusLevel: 'success',
  repairStartDate: '2024-01-15',
  mileageStart: 50000,
  repairEndDate: '2024-01-20',
  mileageEnd: 50100,
  partPurchaseDate: null,
  mileagePartPurchase: null,
  partNumber: null,
  issues: [],
  attachments: [
    {
      fileId: 'detail-file-1',
      filename: 'claim-report.pdf',
      contentType: 'application/pdf',
    },
  ],
};

export const claraClaimDetailWithIssuesMockResponse: GetServiceCaseIntegrationsClaraClaimDetailApiResponse =
  {
    claimNumber: 'CLR-2024-002',
    claimType: '1',
    status: 'RETURNED',
    statusLevel: 'warning',
    repairStartDate: '2024-02-01',
    mileageStart: 60000,
    repairEndDate: '2024-02-05',
    mileageEnd: 60200,
    partPurchaseDate: '2024-01-10',
    mileagePartPurchase: 55000,
    partNumber: 'PART-123',
    issues: [
      {level: 'warning', content: 'Missing documentation for part replacement'},
      {level: 'error', content: 'Mileage discrepancy detected'},
    ],
    attachments: [
      {
        fileId: 'detail-file-2',
        filename: 'part-invoice.pdf',
        contentType: 'application/pdf',
      },
      {
        fileId: 'detail-file-3',
        filename: 'damage.jpeg',
        contentType: 'image/jpeg',
      },
    ],
  };
